
import React, { useEffect } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import './modalstyle.css'
import { useSchedulerContext } from '../context/SchedulerContext';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { Container, FormLabel, Row, ToastContainer } from 'react-bootstrap';
import { Button, ModalFooter, Label } from 'reactstrap';
import DeleteIcon from '@mui/icons-material/Delete';


const ModalReusable = ({ title, slotInfo, event }) => {
    const { modal, toggle } = useSchedulerContext();

    const { setModal, addEventInput, updateEvent, deleteEvent } = useSchedulerContext();


    const initialValues = {
        id: new Date().getMilliseconds(),
        start: slotInfo?.start,
        end: slotInfo?.end,
        title: '',

    }
    const updateInitialValues = {
        id: event?.id,
        start: event?.start,
        end: event?.end,
        title: event?.title

    }

    const onSubmit = (values) => {
        console.log("FormData", values)
        if (event) {
            updateEvent(values);
        }
        else {
            addEventInput(values);
        }

        setModal(false)
    }


    return (
        <>
            <Modal isOpen={modal} toggle={toggle} >
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody>
                    <Formik initialValues={!event ? initialValues : updateInitialValues} onSubmit={onSubmit}>
                        {
                            formik => {
                                return (
                                    <>
                                        <Container>
                                            <Form>
                                                <Row>
                                                    <FormLabel>Start Time</FormLabel>
                                                    <Field name="start" type="text" disabled component={TextField} className="schedulerInput" />
                                                </Row>
                                                <Row>
                                                    <FormLabel>End Time</FormLabel>
                                                    <Field name="end" type="text" disabled component={TextField} className="schedulerInput" />
                                                </Row>
                                                <Row>
                                                    <FormLabel>Event Title</FormLabel>
                                                    <Field name="title" type="text" component={TextField} className="schedulerInput" />
                                                </Row>

                                                {event==='' ? (
                                                    <ModalFooter>
                                                        <Button color='success' type='submit'>Create</Button>
                                                    </ModalFooter>
                                                ) :
                                                    (
                                                        <ModalFooter>
                                                            <Button color='success' type='submit'>Update</Button>
                                                            <Button color='danger' type='button' onClick={() => { deleteEvent(formik.values.id) }} > <DeleteIcon /> </Button>
                                                        </ModalFooter>
                                                    )
                                                }
                                            </Form>
                                        </Container>
                                    </>
                                )
                            }
                        }
                    </Formik> :
                    <ToastContainer />
                </ModalBody>
            </Modal>


        </>
    )
}

export default ModalReusable